import { render, staticRenderFns } from "./ModalCheckItemStandard.vue?vue&type=template&id=5a47abe0&scoped=true&"
import script from "./ModalCheckItemStandard.vue?vue&type=script&lang=js&"
export * from "./ModalCheckItemStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47abe0",
  null
  
)

export default component.exports